  <!-- error-500 start-->
  <div class="error-wrapper">
    <div class="container"><img class="img-100" src="assets/images/other-images/sad.png" alt="">
      <div class="error-heading">
        <h2 class="headline font-primary alert-danger">500</h2>
      </div>
      <div class="col-md-8 offset-md-2">
        <p class="sub-content">  Une erreur inattendue s'est produite. Veuillez réessayer plus tard.</p>
      </div>
      <div><a class="btn btn-primary-gradien btn-lg" (click)="back()">Retour</a></div>
    </div>
  </div>
  <!-- error-500 end-->
